"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppCard = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importStar(require("react"));
const DefaultIcon = core_1.getComponent('LauncherDefaultIcon');
const AppCard = ({ plugin, size }) => {
    const { __ } = core_1.useIntl();
    const { theme } = core_1.useTheme();
    const { navigate } = core_1.useNavigation();
    const onPress = react_1.useCallback(() => navigate(plugin.indexRoute), [plugin]);
    if (!size) {
        return null;
    }
    // Becaues of padding in the parent view
    const iconSize = size - (theme.spacing.unit * 2);
    return (react_1.default.createElement(components_1.TouchableItem, { onPress: onPress },
        react_1.default.createElement(components_1.View, { style: {
                alignItems: 'center',
                paddingHorizontal: theme.spacing.unit,
                paddingVertical: theme.spacing.unit * 2,
                width: size,
            } },
            react_1.default.createElement(components_1.View, { style: { height: iconSize, width: iconSize } }, plugin.icon ? (react_1.default.createElement(components_1.PluginIcon, { id: plugin.key, size: iconSize })) : (react_1.default.createElement(DefaultIcon, { size: size }))),
            react_1.default.createElement(components_1.Body2, { style: { paddingTop: theme.spacing.unit }, ellipsizeMode: "tail", numberOfLines: 1 }, __(plugin.name)))));
};
exports.AppCard = AppCard;
exports.AppCard.displayName = 'AppCard';
